import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-order-save-menu',
  templateUrl: './order-save-menu.component.html',
  styles: [
    `
      .order-save-controls {
        display: flex;
        align-items: center;
        gap: 4px;
      }
    `,
  ],
})
export class OrderSaveMenuComponent {
  @Input() orderForm: FormGroup;
  @Input() variant: 'order' | 'repair' = 'order';
  @Input() splitSave = false;
  @Output() saveOrder = new EventEmitter<{ destination: string }>();

  get isDispensed(): boolean {
    return this.orderForm?.get('status')?.value === 'DISPENSED';
  }

  get isFrameOnly(): boolean {
    return !!this.orderForm?.getRawValue()?.frameOnly;
  }

  onSave(destination: string): void {
    this.saveOrder.emit({ destination });
  }
}
